import CustomAxios from "..";

export const uploadChallanges = async (formData, fileName) => {
    try {
      const response = await CustomAxios.post(
        `/challenge/challenge/json?fileName=${encodeURIComponent(fileName)}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading plan:", error);
      throw error;
    }
  };
  
export const getChallenges = async (params={}) => {
  try {
    const response = await CustomAxios.get("/challenge/challenge",{params});
    return response.data;
  } catch (error) {
    console.error("Error fetching challenges:", error);
    throw error;
  }
};

export const getChallengesById = async (id) => {
  try {
    const response = await CustomAxios.get(`/challenge/challenge/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching challenges:", error);
    throw error;
  }
};

export const deleteChallengesById = async (id) => {
  try {
    const response = await CustomAxios.delete(`/challenge/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};

export const updatestatusChallengesById = async (id) => {
  try {
    const response = await CustomAxios.patch(`/challenge/update-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};

